export default "__VITE_ASSET__B5f9K0XW__"